import { render, staticRenderFns } from "./galleryDetailCom.vue?vue&type=template&id=7f0bcdda&scoped=true"
import script from "./galleryDetailCom.vue?vue&type=script&lang=js"
export * from "./galleryDetailCom.vue?vue&type=script&lang=js"
import style0 from "./galleryDetailCom.vue?vue&type=style&index=0&id=7f0bcdda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0bcdda",
  null
  
)

export default component.exports